import React from "react";
import PropTypes from "prop-types";
import SidebarIconSvg from "./SidebarIconSvg";

const SidebarIconBuilding = ({ className, size }) => (
  <SidebarIconSvg className={className} size={size}>
    <rect x="4" y="3" width="16" height="18" />
    <line x1="9" y1="21" x2="9" y2="3" />
    <line x1="15" y1="21" x2="15" y2="3" />
    <line x1="4" y1="9" x2="20" y2="9" />
    <line x1="4" y1="15" x2="20" y2="15" />
  </SidebarIconSvg>
);

SidebarIconBuilding.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number
};

export default SidebarIconBuilding;
